import { SERVER_URL } from "../constants/app.constants";
export const LOGIN_DIALOGS = {
  invalidFRGTPWDetails: "Please enter correct User name and Email ID.",
  invalidFRGTDetails: "Details are invalid.",
  problemSendingEmail: "There is problem sending email, please contact admin.",
  emailSuccess:
    "Password sent successfully to your registered email address. Kindly review your email inbox for instructions on resetting your password.",
  fillDetailsFRGT: "Please fill the details properly.",
  accountDeactivate:
    "Your account has been deactivated,please contact administrator.",
  invalidLoginDetails: "Please enter valid login details.",
  loginFailed: "Login failed!",
  invalidEmailAddress: "Email Address is not valid.",
  incorrectPW: "Current Password is incorrect.",
  newPWlenght: "Please enter password of min 5 character.",
  passwordMatch: "New Password does not match with Confirm Password.",
  changePasswordDetails: "Please enter required fields properly.",
  technicalError: "There is some technical issue, please try after sometime.",
  invalidResetPassword: "Please enter valid passwords.",
  invalidPasswordMismatch: "Entered passwords do not match.",
  successResetPassword: `<span style="color:green">Password updated successfully!!</span><br/><span style="color:black">Please <a href="${SERVER_URL}login">login</a></span>`,
  invalidToken: `Invalid Token or Token is expired. <br/>Generate new token <a href="${SERVER_URL}forgotpassword">Generate Token</a>`,
  changePasswordSuccess: "Password updated successfully."
};

export const SCHEDULING_DIALOGS = {
  propertyAddedSuccess: "Property Added Successfully!",
  propertyUpdatedSuccess: "Property updated sucessfully",
  propertyAddFailed: "Failed to Add Property",
  propertyNameRequired: "Please enter Property Name.",
  clientContactRequired: "Please select Client Contact.",
  estimatedYardsRequired: "Please enter Estimated Yards.",
  productColorRequired: "Please select Product/Color.",
  propertyAddressRequired: "Please enter Property Address.",
  cityRequired: "Please enter City.",
  stateRequired: "Please enter State.",
  outsideServiceArea: "Outside our service area.",
  zipRequired: "Please enter Zip.",
  propertyNotesRequired: "Please enter Property Notes.",
  uploadMapRequired: "Please upload Map.",
  invalidMapFileType: "Only JPG, PNG, WEBP, or GIF files are allowed.",
  mapFileTooLarge: "File size must be less than 5 MB.",
  requestSentSuccess: "Request Sent Successfully!",
  requestSendFailed: "Failed to Send",
  readyForMulchLabel: "Ready For Mulch",
  readyForMulchNoDescription: "No description available.",
  readyForMulchLoadFailed: "Failed to load description.",
  priorityLabel: "Priority",
  priorityNoDescription: "No description available.",
  priorityLoadFailed: "Failed to load priority.",
  priorityDateDeliveredLabel: "Date Delivered",
  confirmPriority: "Confirm Priority",
  priorityConfirmed: "Priority Confirmed!",
  priorityConfirmFailed: "Failed to Confirm Priority",
  confirmPropertyReadiness: "Confirm Property Readiness",
  propertyReadinessConfirmed: "Property Readiness Confirmed!",
  propertyReadinessConfirmFailed: "Failed to Confirm Property Readiness",
  readinessMissingJob:
    "Unable to confirm property readiness. Please refresh the schedule list and try again.",
  priorityMissingJob:
    "Unable to confirm priority. Please refresh the schedule list and try again.",
  closeButton: "Close",
  cancelButton: "Cancel",
  confirmButton: "Confirm",
  approvalUpdateSuccess: "Approved Updated Successfully!",
  approvalUpdateFailed: "Failed to Update Approved",
  approvalUpdateError: "An error occurred during update.",
  moveFromListLabel: "Move From List",
  confirmMoveFromList:
    "Are you sure you want to remove this record from the Scheduled Jobs list?",
  moveFromListSuccess:
    "The record was successfully removed from the Scheduled Jobs list.",
  moveFromListFailed: "Failed to Move From List",
  moveFromListMissingJob:
    "Unable to move this record from the list. Please refresh the schedule list and try again.",
};

export const ERROR_MESSAGE =
  //"The data is temporarily unavailable. Please try again later.";
  "No data available."

export const NODATA_ERROR_MESSAGE = "No records found";
